import React from 'react';
import { motion } from 'framer-motion';

export default function GoldButton({ 
  children, 
  onClick, 
  variant = 'primary', 
  disabled = false, 
  className = '',
  testId = 'gold-button',
  type = 'button'
}) {
  const baseClass = 'font-semibold rounded-full transition-all duration-300 ease-out';
  
  const variants = {
    primary: `bg-gradient-to-r from-[#F5A623] to-[#FF9500] text-white px-8 py-4 hover:from-[#FF9500] hover:to-[#F5A623] hover:shadow-[0_0_30px_rgba(245,166,35,0.5)] hover:scale-105 ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    secondary: `border-2 border-[#F5A623] text-[#F5A623] px-6 py-3 hover:bg-[#F5A623] hover:text-white hover:shadow-lg ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`,
    ghost: `text-white px-4 py-2 hover:bg-white/10 hover:text-[#F5A623] ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`
  };

  return (
    <motion.button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`${baseClass} ${variants[variant]} ${className}`}
      data-testid={testId}
      whileTap={!disabled ? { scale: 0.95 } : {}}
    >
      {children}
    </motion.button>
  );
}